<template>
    <div id="VehicleFeatureList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name"><div class="page-title">Equipment Features</div>
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="web-action-btn">
                        <div class="btn-groups text-right">
                            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                                <i class="fp-export"></i> Export
                            </a>
                            <!-- <router-link  v-if="canAddAsset" class="btn btn-primary" v-bind:to="{name: 'AssetComponentCreate'}" > <i class="fp-add"></i> Add Component</router-link> -->
                            <!-- <router-link  v-if="canAddAsset && hideButton === false" class="btn btn-primary" v-bind:to="{name: 'AssetCreate'}" > <i class="fp-add"></i> Add</router-link> -->
                            <!-- <router-link v-if="programMode && hideButton === false" class="btn btn-secondary" v-bind:to="{name: 'ProgramList'}" > <i class="fp-back"> </i> Back</router-link> -->

                        </div>
                    </div>
                    <div class="mobile-action-btn elipse-btn">
                        <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left" aria-expanded="false" v-on:click.prevent="myFunction">
                            <i class="fp-ellipsis-v"></i>
                        </button>
                        <div id="myDropdown" class="dropdown-content">
                            <ul>
                                <li><a href="javascript:void(0)" class="" v-on:click="exportReports()">Export</a></li>
                                <!-- <li> <router-link v-if="hideButton === false && canAddAsset" v-bind:to="{name: 'AssetCreate'}"> Add</router-link> </li>
                                <li> <router-link v-if="hideButton === false && canAddAsset" v-bind:to="{name: 'AssetComponentCreate'}"> Add Component</router-link> </li> -->

                            </ul>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content asset-lists">

                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'assetFeatureList'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                            <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                            <section class="bg-white data-table">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'assetFeatureList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                        ref="listVehicleFeatureTable"
                                        mode="remote"
                                        title="Asset Feature"
                                        @on-page-change="onPageChange"
                                        @on-selected-rows-change="selectionChanged"
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange"
                                        @on-sort-change="onSortChange"
                                        :totalRows="totalRecords"
                                        :columns="userColumns"
                                        :rows="rows"
                                        @on-select-all="onSelectAll"
                                        :pagination-options="{
                                            enabled: false,
                                            position: 'both',
                                            setCurrentPage:listCurrentPage,
                                            perPage: perPage,
                                            perPageDropdown:dropDownPerPage,
                                            dropdownAllowAll: false,
                                        }"
                                        :select-options="{
                                            enabled: false,
                                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                            selectionInfoClass: 'custom-class',
                                            selectionText: 'rows selected',
                                            clearSelectionText: 'clear',
                                        }"
                                        :search-options="{
                                            enabled: false,
                                        }"
                                        :sort-options="{
                                            enabled: true,
                                            initialSortBy: {field: 'unit_no', type: 'asc'}
                                        }"
                                >

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

    import EventBus from "./event-bus";
    import Vue from "vue";






    import {commonMixins} from '../mixins/commonMixins';
    import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "VehicleFeatureList",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "Asset Feature List | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            pageTitle:"Asset Feature List",
            hideButton: false,
            availabilityFromDate:null,
            availabilityToDate:null,
            availabilityLocation:"",
            availabilityAssetType:"",
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            canViewAsset:true,
            userColumns:[],
            columns: [
                //  {
                //     label: 'Actions',
                //     field: 'action',
                //     sortable: false,
                //     hidden:false,
                // },
                {
                    label: 'Unit Number',
                    field: 'unit_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    width:'90px',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "#Unit", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    html:true
                },

                {
                    label: 'Status',
                    field: 'status',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterDropdownItems: [],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "Date In Service",
                    field: "date_in_service",
                    filterable: true,
                    fpFieldType:"custom_date",
                    hidden:false,
                    filterOptions: {
                        enabled: false,
                        placeholder: "MM/DD/YYYY",
                        filterValue: "",
                        trigger: "enter"
                    }
                },
                {
                    label: "Item Serial Number",
                    field: "vin",
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false,
                        placeholder: "VIN",
                        filterValue: "",
                        trigger: "enter"
                    }
                },
                {
                    label: "Equipment Group",
                    field: "asset_group",
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false,
                        placeholder: "Group",
                        filterValue: "",
                        trigger: "enter"
                    }
                },
                {
                    label: "Equipment Group Name",
                    field: "asset_group_name",
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false,
                        placeholder: "Group Name",
                        filterValue: "",
                        trigger: "enter"
                    }
                },
                {
                    label: "Equipment Manufacturer",
                    field: "vehicle_manufacturer",
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false,
                        placeholder: "Equipment Manufacturer",
                        filterValue: "",
                        trigger: "enter"
                    }
                },
                {
                    label: "Manufacturer Name",
                    field: "vehicle_manufacturer_desc",
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false,
                        placeholder: "Equipment Manufacturer",
                        filterValue: "",
                        trigger: "enter"
                    }
                },
                {
                    label: "Equipment Model",
                    field: "vehicle_model",
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false,
                        placeholder: "Equipment Model",
                        filterValue: "",
                        trigger: "enter"
                    }
                },
                {
                    label: "Model Description",
                    field: "vehicle_model_desc",
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false,
                        placeholder: "Equipment Model",
                        filterValue: "",
                        trigger: "enter"
                    }
                },
                {
                    label: "Equipment Type",
                    field: "asset_type",
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false,
                        placeholder: "Asset Type",
                        filterValue: "",
                        trigger: "enter"
                    }
                },
                {
                    label: "Equipment Type Description",
                    field: "asset_type_desc",
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false,
                        placeholder: "Asset Type",
                        filterValue: "",
                        trigger: "enter"
                    }
                },
                {
                    label: "Feature Code",
                    field: "feature_code",
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false,
                        placeholder: "Feature Code",
                        filterValue: "",
                        trigger: "enter"
                    }
                },
                {
                    label: "Feature Description",
                    field: "feature_name",
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false,
                        placeholder: "Feature Name",
                        filterValue: "",
                        trigger: "enter"
                    }
                },
                {
                    label: "Feature Value",
                    field: "feature_value",
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false,
                        placeholder: "Feature Value",
                        filterValue: "",
                        trigger: "enter"
                    },
                },
                {
                    label: 'Parent Unit Number',
                    field: 'parent_unit_number',
                    fpFieldType:"option",
                    filterable: false,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Parent Unit Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Attachment Date',
                    field: 'attch_dt',
                    filterable: false,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Removal Date',
                    field: 'date_rmvl',
                    filterable: false,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Equipment Pool',
                    field: 'asset_pool',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Asset Pool", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Current Facility Code',
                    field: 'location',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Facility", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Current Facility Description',
                    field: 'location_desc',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Facility Description", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Current Region Code',
                    field: 'region_code',
                    filterable: false,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Region Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Current Region Description',
                    field: 'region_desc',
                    filterable: false,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Region Description", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false,
                },
                {
                    label: 'Customer Number',
                    field: 'customer',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Customer Name',
                    field: 'customer_name',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Customer Unit Number',
                    field: 'customer_unit_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    width:'90px',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "#Customer Unit", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    html:true
                },
                // {
                //     label: 'Ownership',
                //     field: 'ownership',
                //     fpFieldType:"option",
                //     filterable: true,
                //     hidden:true,
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "Ownership", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                // {
                //     label: 'Odometer Reading',
                //     field: 'odometer_reading',
                //     fpFieldType:"integer",
                //     filterable: true,
                //     hidden:true,
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "Reading", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                // {
                //     label: 'Reading Updated At',
                //     field: 'odometer_reading_time',
                //     filterable: true,
                //     fpFieldType:"date",
                //     hidden:true,
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "MM/DD/YYYY", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                // {
                //     label: 'Purchase Date',
                //     field: 'purchase_date',
                //     filterable: true,
                //     fpFieldType:"date",
                //     hidden:true,
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "MM/DD/YYYY", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                // {
                //     label: 'Date Added',
                //     field: 'date_added',
                //     filterable: true,
                //     fpFieldType:"date",
                //     hidden:true,
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "MM/DD/YYYY", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },

            ],
            rows: [],
            totalRecords: 0,
            canDeleteAsset: false,
            loading:false,
            canAddAsset:false,
            canUpdateAsset:false,
            accessCheckAvailability:false,
            selectedFile:"",
            recallMode:false,
            errorDetails:'',
            recalls:'',
            recallArr:[],
            assetRowCheckbox:false,
            action:"list",
            submitBtnText:"Submit",
            pageKey:"_vehicle_list_",
            programMode:false,
            batchProcess:0,
            batchNum:"",
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'equipment_feature_report') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_asset') {
                            self.canDeleteAsset = true;
                        }
                        if (permissions[i].name == 'add_asset') {
                            self.canAddAsset = true;
                            self.canUpdateAsset = true;
                        }
                        if (permissions[i].name == 'view_asset') {
                            self.canViewAsset = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },

        mounted: function() {

            var self = this;
            self.getPermissions();

        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listVehicleFeatureTable.unselectAllInternal();
            },
            selectionChanged(param) {
                var self = this;
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                return;
                // console.log(self.computed.selectedRows);
                //var rowData = self.$refs['listVehicleTable'].selectedRows;
                //console.log(rowData);
            },
            // exportReports: function() {
            //     EventBus.$emit("clearSelection", false);
            //     var self = this;
            //     this.action = "export";
            //     this.loadList();
            // },

            loadList() {

                var self = this;
                self.loading = true;

                //self.serverParams.columnFilters = params;

                var selectedRows = [];

                //because on first load list not initialize
                var data = this.$refs['listVehicleFeatureTable'].selectedRows;
                for ( var i = 0; i < data.length; i++ ) {
                    selectedRows.push(this.$refs['listVehicleFeatureTable'].selectedRows[i].id)
                }

                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    selectedRows:selectedRows,
                    action:self.action,
                    selectedAll:self.serverParams.selectedAll

                };

                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/asset-feature-report/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                              if ( self.action == "export" ||  self.action == "export_queue") {

                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {

                                    if ( self.action == "export" ) {

                                        self.excel = data.content.web;
                                        var save = document.createElement("a");
                                        save.href = self.excel;
                                        save.download = data.content.web;
                                        save.target = "_blank";

                                        document.body.appendChild(save);
                                        save.click();
                                        document.body.removeChild(save);

                                    } else {

                                        self.batchProcess = 1;
                                        self.batchNum = data.content;
                                    }

                                }

                                self.action = "list";
                                // self.loadList();
                                return;

                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;

                        if ( self.action == "export" ) {
                            self.generateStatusCodeMessage(jqXHR,true,'export-asset-feature-list')
                        }else{
                            self.generateStatusCodeMessage(jqXHR,false,'get-asset-feature-list')
                        }

                    }
                });
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/AssetFeatureReport.vue